import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isReseller } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  // A reseller has no rxk_customers profile — every /my/* page assumes one,
  // so keep them in their own portal instead of showing a broken customer
  // account page.
  if (isReseller) {
    return <Navigate to="/reseller" replace />;
  }
  return <>{children}</>;
}